import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-feature-business-rule',
  templateUrl: './feature-business-rule.component.html',
  styleUrl: './feature-business-rule.component.scss'
})

export class FeatureBusinessRuleComponent implements OnInit {
  form: FormGroup;

  units = ['m', 'cm', 'mm'];
  accuracyProperties = ['Low', 'Medium', 'High'];
businessRules = ['Rule 1', 'Rule 2', 'Rule 3'];

  constructor(private fb: FormBuilder,    public dialogRef: MatDialogRef<FeatureBusinessRuleComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { feature: string, }) {}

  ngOnInit(): void {
this.form = this.fb.group({

  businessRule: [null],
  mode: ['Assert'],
  businessRuleDescription: ['']
});


  }

  onClose() {
          console.log('Form values:', this.form.value);
    this.dialogRef.close();

    // if (this.form.valid) {
    //   console.log('Form values:', this.form.value);
    // }
  }

  onLock() {
    console.log('Cancelled');
        this.dialogRef.close();

  }

}
